<template>
  <v-layout wrap justify-center>
    <ServerError v-if="ServerError" />
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="blue"
      spinner="mini-spinner"
    />
    <v-snackbar
      :timeout="3000"
      :value="true"
      right
      color="red"
      v-model="showsnackbar"
    >
      <span style="font-size: 20px"> {{ msg }}</span>
    </v-snackbar>
    <v-flex xs12 lg11 pt-6>
      <v-layout wrap justify-center>
        <v-flex xs12>
          <v-card
            class="mx-auto elevation-1 pa-6"
            max-width="1088px"
            align="center"
            outlined
          >
            <v-layout wrap justify-space-between>
              <v-flex
                xs12
                sm9
                pa-2
                class="text-left nsbold"
                style="font-weight: 700; font-size: 20px"
                >Leaves
              </v-flex>
              <v-flex
                xs12
                sm3
                py-2
                px-1
                align-self-center
                class="text-left nsregular"
              >
                <v-select
                  v-model="filter"
                  :items="filterList"
                  dense
                  class="rounded-xl"
                  label="Leave Status"
                  outlined
                  hide-details
                  clearable
                ></v-select>
              </v-flex>

              <v-flex
                xs12
                sm3
                py-2
                px-1
                align-self-center
                class="text-left nsregular"
              >
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="fromDate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fromDate"
                      label="From Date"
                      outlined
                      readonly
                      dense
                      hide-details
                      clearable
                      class="rounded-xl"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fromDate"
                    no-title
                    scrollable
                    @change="$refs.menu.save(fromDate)"
                  >
                    <v-spacer></v-spacer>
                  </v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex
                xs12
                sm3
                py-2
                px-1
                align-self-center
                class="text-left nsregular"
              >
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :return-value.sync="toDate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="toDate"
                      label="To Date"
                      readonly
                      outlined
                      dense
                      hide-details
                      clearable
                      class="rounded-xl"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="toDate"
                    no-title
                    scrollable
                    @change="$refs.menu2.save(toDate)"
                  >
                    <v-spacer></v-spacer>
                  </v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex
                xs12
                sm3
                py-2
                px-1
                align-self-center
                class="text-left nsregular"
              >
                <v-select
                  v-model="busId"
                  :items="busList"
                  dense
                  class="rounded-xl"
                  label="Buses"
                  item-text="name"
                  item-value="_id"
                  outlined
                  hide-details
                  clearable
                ></v-select>
              </v-flex>
              <v-flex
                xs12
                sm3
                py-2
                px-1
                align-self-center
                class="text-left nsregular"
              >
                <v-select
                  v-model="tripId"
                  :items="tripList"
                  dense
                  class="rounded-xl"
                  label="Trips"
                  item-text="name"
                  item-value="_id"
                  outlined
                  hide-details
                  clearable
                ></v-select>
              </v-flex>
            </v-layout>

            <v-layout wrap v-if="leaveList">
              <v-flex xs12 align-self-center v-if="leaveList.length > 0">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Applied Date<span
                            class="hidden-md-and-up"
                            style="color: #ffffff"
                            >______________</span
                          >
                        </th>
                        <th class="text-left">Student</th>

                        <th class="text-left">
                          Leave On<span
                            class="hidden-md-and-up"
                            style="color: #ffffff"
                            >______________</span
                          >
                        </th>
                        <th class="text-left">Trip Details</th>
                        <th class="text-left">Leave Status</th>
                        <th class="text-left">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="text-left regular"
                        v-for="(item, i) in leaveList"
                        :key="i"
                      >
                        <td>
                          <span v-if="item.create_date">
                            {{ formatDate(item.create_date) }}
                          </span>
                        </td>
                        <td>
                          <span
                            class="vhover"
                            v-if="item.studentId"
                            style="cursor: pointer"
                            @click="
                              $router.push('/profile?id=' + item.studentId._id)
                            "
                          >
                            {{ item.studentId.name }} [{{
                              item.studentId.admissionNo
                            }}]
                          </span>
                        </td>
                        <td>
                          <v-layout wrap justify-start>
                            <v-flex
                              xs12
                              pa-1
                              align-self-center
                              v-for="(leave, l) in item.leaveOn"
                              :key="l"
                            >
                              <span>
                                {{ formatDateOnly(leave) }}
                                <span
                                  v-if="
                                    item.leaveOn.length > 1 &&
                                    l != item.leaveOn.length - 1
                                  "
                                  >,</span
                                >
                              </span>
                            </v-flex>
                          </v-layout>
                        </td>

                        <td>
                          <v-layout wrap justify-start v-if="item.tripIds">
                            <v-flex
                              xs12
                              pa-1
                              align-self-center
                              v-for="(trip, t) in item.tripIds"
                              :key="t"
                            >
                              <span>
                                {{ trip.name }}
                                <span v-if="trip.busid"
                                  >({{ trip.busid.name }})</span
                                >
                                <span
                                  v-if="
                                    item.tripIds.length > 1 &&
                                    t != item.tripIds.length - 1
                                  "
                                  >,</span
                                >
                              </span>
                            </v-flex>
                          </v-layout>
                        </td>

                        <td>
                          <span v-if="item.status">
                            {{ item.status }}
                          </span>
                        </td>

                        <!-- <td>
                          <v-dialog v-model="item.vdialog" width="70%">
                            <template v-slot:activator="{ on, attrs }">
                              <span
                                class="vhover"
                                v-bind="attrs"
                                v-on="on"
                                @click="getAllRoutes(item.routeId._id)"
                              >
                                {{ item.routeId.name }}
                              </span>
                            </template>

                            <v-card v-if="allRoutes">
                              <v-toolbar
                                dark
                                color="#766BC0"
                                dense
                                flat
                                class="body-2"
                              >
                                <v-toolbar-title> Details </v-toolbar-title>
                              </v-toolbar>

                              <v-layout wrap pa-4>
                                <v-flex xs12 align-self-center pa-2>
                                  <span class="nsbold">
                                    {{ item.routeId.name }}
                                  </span></v-flex
                                >
                                <v-flex xs12 align-self-center pa-2>
                                  <span class="nsbold">
                                    Bus Stops :
                                  </span></v-flex
                                >

                                <v-flex
                                  xs12
                                  align-self-center
                                  pa-2
                                  v-if="allRoutes"
                                >
                                  <v-timeline dense clipped>
                                    <v-timeline-item
                                      fill-dot
                                      color="error"
                                      small
                                      v-for="(sub, s) in allRoutes"
                                      :key="s"
                                    >
                                      <span>
                                        {{ sub.placeId.name }}
                                      </span>
                                    </v-timeline-item>
                                  </v-timeline>
                                </v-flex>
                              </v-layout>

                              <v-divider></v-divider>

                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  text
                                  @click="item.vdialog = false"
                                >
                                  Close
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </td> -->

                        <td>
                          <v-layout wrap>
                            <v-flex xs12 pa-1 align-self-center v-if="item">
                              <v-dialog v-model="item.vdialog" width="70%">
                                <template v-slot:activator="{ on, attrs }">
                                  <span v-bind="attrs" v-on="on"
                                    ><v-icon style="cursor: pointer"
                                      >mdi-eye</v-icon
                                    ></span
                                  >
                                </template>

                                <v-card>
                                  <v-toolbar
                                    dark
                                    color="#766BC0"
                                    dense
                                    flat
                                    class="body-2"
                                  >
                                    <v-toolbar-title> Details </v-toolbar-title>
                                  </v-toolbar>

                                  <v-layout wrap pa-4>
                                    <v-flex xs12 sm6 align-self-center pa-2>
                                      <span class="nsregular"
                                        >Applied Date :
                                        <span class="nsbold">
                                          {{ formatDate(item.create_date) }}
                                        </span>
                                      </span></v-flex
                                    >

                                     <v-flex xs12 sm6 align-self-center text-right pa-2>
                                      <span class="nsregular" v-if="item.status"
                                        >Leave Status :
                                        <span class="nsbold">
                                          {{ item.status }}
                                        </span>
                                      </span></v-flex
                                    >
                                    <v-flex xs12 align-self-center pa-2>
                                      <span class="nsregular"
                                        >Student Details :
                                      </span>
                                      <span
                                        class="vhover"
                                        v-if="item.studentId"
                                        style="cursor: pointer"
                                        @click="
                                          $router.push(
                                            '/profile?id=' + item.studentId._id
                                          )
                                        "
                                      >
                                        {{ item.studentId.name }} [{{
                                          item.studentId.admissionNo
                                        }}]
                                      </span>
                                    </v-flex>
                                    <v-flex xs12 align-self-center pa-2>
                                      <span class="nsregular">
                                        Leave On :
                                      </span></v-flex
                                    >

                                    <v-flex xs12 align-self-center pa-2>
                                      <v-layout wrap>
                                        <v-flex
                                          xs12
                                          pa-1
                                          align-self-center
                                          v-for="(leave, l) in item.leaveOn"
                                          :key="l"
                                        >
                                          <span>
                                            {{ formatDateOnly(leave) }}
                                            <span
                                              v-if="
                                                item.leaveOn.length > 1 &&
                                                l != item.leaveOn.length - 1
                                              "
                                              >,</span
                                            >
                                          </span>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex xs12 align-self-center pa-2>
                                      <span class="nsregular">
                                        Trip Details :
                                      </span></v-flex
                                    >

                                    <v-flex xs12 align-self-center pa-2>
                                      <v-layout wrap>
                                        <v-flex
                                          xs12
                                          pa-1
                                          align-self-center
                                          v-for="(trip, t) in item.tripIds"
                                          :key="t"
                                        >
                                          <span>
                                            {{ trip.name }}
                                            <span v-if="trip.busid"
                                              >({{ trip.busid.name }})</span
                                            >
                                            <span
                                              v-if="
                                                item.tripIds.length > 1 &&
                                                t != item.tripIds.length - 1
                                              "
                                              >,</span
                                            >
                                          </span>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>

                                  <v-divider></v-divider>

                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      color="primary"
                                      text
                                      @click="item.vdialog = false"
                                    >
                                      Close
                                    </v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </v-flex>
                          </v-layout>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-flex>
              <v-flex xs12 v-else align-self-center pa-4 pa-sm-16 text-center>
                <span>No Leave Data Found!!</span>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>

      <v-dialog width="450px" v-model="dialoge">
        <v-card>
          <v-toolbar dark color="#766BC0" dense flat class="body-2">
            <v-toolbar-title> Confirm Delete </v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pa-4 black--text"
            >Are you sure you want to delete this record?
          </v-card-text>
          <v-card-actions class="pt-3">
            <v-spacer></v-spacer>
            <v-btn
              color="grey"
              text
              class="body-2 font-weight-bold"
              @click="dialoge = false"
              >Cancel</v-btn
            >
            <v-btn
              color="#766BC0"
              class="body-2 font-weight-bold"
              outlined
              @click="deleteTrip()"
              >OK</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- <v-dialog max-width="70%" v-model="editdialogue">
        <v-card>
          <v-toolbar dark color="#766BC0" dense flat class="body-2">
            <v-toolbar-title> Edit Details </v-toolbar-title>
          </v-toolbar>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-layout wrap pa-4>
              <v-flex xs12 sm6 align-self-center pa-2>
                <v-text-field
                  dense
                  hide-details
                  outlined
                  required
                  label="Trip Name"
                  v-model="curItem.name"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 align-self-center pa-2>
                <v-select
                  dense
                  hide-details
                  outlined
                  required
                  :item-text="(item) => item.name + ' - ' + item.type"
                  item-value="_id"
                  :items="sectionList"
                  label="Choose Section"
                  v-model="curItem.sectionId"
                ></v-select>
              </v-flex>

              <v-flex xs12 sm6 align-self-center pa-2>
                <v-select
                  dense
                  hide-details
                  outlined
                  required
                  item-text="name"
                  item-value="_id"
                  :items="routeList"
                  label="Choose Route"
                  v-model="curItem.routeId"
                ></v-select>
              </v-flex>

              <v-flex xs12 sm6 align-self-center pa-2>
                <v-select
                  dense
                  hide-details
                  outlined
                  readonly
                  required
                  item-text="name"
                  item-value="_id"
                  :items="busList"
                  label="Choose Bus"
                  v-model="curItem.busId"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-card-actions class="pt-3">
              <v-spacer></v-spacer>
              <v-btn
                color="grey"
                text
                class="body-2 font-weight-bold"
                @click="editdialogue = false"
                >Cancel</v-btn
              >
              <v-btn
                :disabled="!valid"
                color="#766BC0"
                class="body-2 font-weight-bold"
                outlined
                @click="editBus()"
                >OK</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog> -->

      <v-layout wrap>
        <v-flex xs12 pt-4 v-if="Pagelength">
          <v-pagination
            small
            color="#766BC0"
            v-model="page"
            :length="Pagelength"
          >
          </v-pagination>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      page: 1,
      Pagelength: 0,
      dialoge: false,
      editdialogue: false,
      showsnackbar: false,
      msg: null,
      appLoading: false,
      ServerError: false,
      valid: true,
      curItem: {},
      tripData: {},
      show2: true,
      doManual: false,
      addDialog: false,
      busList: [],
      routeList: [],
      tripList: null,
      filterList: ["Active", "Cancelled"],
      filter: "Active",
      allRoutes: null,
      leaveList: [],
      tripId: null,
      busId: null,
      menu: false,
      menu2: false,
      fromDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      toDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
    };
  },
  beforeMount() {
    if (this.fromDate) {
      var dt = new Date();

      // var day=dt.getDate()
      dt.setDate(dt.getDate() - 0);
      // dt.setDate(dt.getDate() - 30 + 1);
      this.fromDate = dt.toISOString().substr(0, 10);
    }
    this.fromDate = null;
    this.toDate = null;
    this.getBus();
  },
  watch: {
    page() {
      this.getData();
    },
    filter() {
      this.getData();
    },
    busId() {
      this.page = 1;
      this.getTrips();

      this.leaveList = [];
      this.Pagelength = 0;
    },
    tripId() {
      this.page = 1;
      if (this.busId) this.getData();
    },

    fromDate() {
      this.page = 1;
      this.getData();
    },
    toDate() {
      this.page = 1;

      this.getData();
    },
  },
  methods: {
    getBus() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/bus/admin/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.busList = response.data.data;
            if (this.busList.length > 0) {
              // this.busId = this.busList[0]._id;

              this.getTrips();
            }
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getTrips() {
      if (this.busId) {
        this.appLoading = true;
        axios({
          method: "post",
          url: "/bus/trip/list",
          headers: {
            token: localStorage.getItem("token"),
          },
          data: {
            busid: this.busId,
          },
        })
          .then((response) => {
            this.appLoading = false;
            if (response.data.status) {
              this.tripList = response.data.data;
              if (this.tripList.length > 0) {
                this.tripId = this.tripList[0]._id;

                this.getData();
              }
            } else {
              this.snackbar = true;
              this.msg = response.data.msg;
            }
          })
          .catch((err) => {
            this.appLoading = false;
            console.log(err);
          });
      }
    },

    getData() {
      this.leaveList = [];
      // if (this.tripId)

      {
        this.appLoading = true;
        axios({
          method: "post",
          url: "/bus/admin/leave/list",
          headers: {
            token: localStorage.getItem("token"),
          },
          data: {
            tripId: this.tripId,
            page: this.page,
            limit: 20,
            from: this.fromDate,
            to: this.toDate,
            status: this.filter,
          },
        })
          .then((response) => {
            this.appLoading = false;
            if (response.data.status) {
              this.leaveList = response.data.data;
              this.Pagelength = Math.ceil(response.data.totalLength / 20);
            } else {
              this.snackbar = true;
              this.msg = response.data.msg;
            }
          })
          .catch((err) => {
            this.appLoading = false;
            console.log(err);
          });
      }
    },

    formatDate(item) {
      var dt = new Date(item);

      // dt.setHours(dt.getHours() - 5);
      // dt.setMinutes(dt.getMinutes() - 30);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        ", " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;

      return strTime;
    },

    formatDateOnly(item) {
      var dt = new Date(item);

      // dt.setHours(dt.getHours() - 5);
      // dt.setMinutes(dt.getMinutes() - 30);
      var day = dt.getDate();
      var year = dt.getFullYear();
      // var hours = dt.getHours();
      // var minutes = dt.getMinutes();
      dt = dt.toString();
      // var ampm = hours >= 12 ? "pm" : "am";
      // hours = hours % 12;
      // hours = hours ? hours : 12;
      // minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = day + " " + dt.slice(4, 7) + " " + year;

      return strTime;
    },
  },
};
</script>
<style scoped></style>
